import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';

const MetricsAndTrust = ({ activeTab }) => {
  const isBusiness = activeTab === 0;

  const stats = isBusiness ? [
    { value: '+10,000', label: 'Leads Extraídos Diariamente' },
    { value: '+45%', label: 'Cierre de Ventas con el CRM' },
    { value: '+300', label: 'Empresas Operando' },
    { value: '24/7', label: 'Soporte y Comunidad' }
  ] : [
    { value: '+5,000', label: 'Alumnos en la Academia' },
    { value: '+1,200', label: 'Contrataciones B2B' },
    { value: 'Top 10%', label: 'Profesionales Élite' },
    { value: '+50', label: 'Cursos y Certificaciones' }
  ];

  return (
    <Box sx={{ background: '#0B0914', py: 10, color: '#fff', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
      <Container maxWidth="lg">
        <Box textAlign="center" mb={6}>
          <Typography variant="h4" fontWeight={800} mb={2}>
            Respaldado por Datos Reales
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.6)', maxWidth: 600, mx: 'auto' }}>
            {isBusiness 
              ? 'No somos solo una herramienta, somos el motor detrás de las agencias de más rápido crecimiento.' 
              : 'Nuestra prioridad es que pases de estudiante a profesional facturando en tiempo récord.'}
          </Typography>
        </Box>

        <Grid container spacing={4} justifyContent="center">
          {stats.map((stat, index) => (
            <Grid item xs={6} md={3} key={index}>
              <motion.div 
                initial={{ opacity: 0, scale: 0.8 }} 
                whileInView={{ opacity: 1, scale: 1 }} 
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
              >
                <Box sx={{ textAlign: 'center', p: 3 }}>
                  <Typography variant="h3" fontWeight="bold" sx={{ display: 'inline-block', paddingRight: '10px', background: 'linear-gradient(90deg, #6C4DE2, #F21C63)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', mb: 1 }}>
                    {stat.value}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', letterSpacing: 1, fontWeight: 'bold' }}>
                    {stat.label}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default MetricsAndTrust;
